var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sync"},[_c('h4',[_vm._v("Update Registrations")]),_c('p',[_c('button',{attrs:{"disabled":_vm.progress},on:{"click":function($event){return _vm.startUpdatePersonRegistrations()}}},[_vm._v("Start")])])])}
var staticRenderFns = []

export { render, staticRenderFns }